import { render } from "./UIInput.vue?vue&type=template&id=4d7de1c0&scoped=true&ts=true"
import script from "./UIInput.vue?vue&type=script&lang=ts"
export * from "./UIInput.vue?vue&type=script&lang=ts"

import "./UIInput.vue?vue&type=style&index=0&id=4d7de1c0&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7de1c0"]])

export default __exports__